import Breadcrumb from '../breadcrumb/Breadcrumb';
import styles from './CategoryDetails.module.scss';

function CategoryDetails({ categories, productCategories, chosen, children, lang }) {
  return (
    <>
      <h2 className={styles.categoryTitle}>{chosen}</h2>
      <div className={styles.breadcrumb}>
        <Breadcrumb
          categories={categories}
          chosen={chosen}
          lang={lang}
        />
        {
          productCategories && (
            <Breadcrumb
              categories={productCategories}
              chosen={chosen}
              lang={lang}
              hideAll
              isProductCategory
            />
          )
        }
      </div>
      {children}
    </>
  );
}

export default CategoryDetails;
